import { EquipmentModal } from '../interfaces';

export const EQUIPMENT_DEFAULT_VALUE: EquipmentModal = {
  equipment: '',
  equipmentType: '',
  manufacturer: '',
  quantity: 0,
  RAD: 0,
};
